<div
  *ngIf="
    selectedType != inputTypes.TEXTAREA && selectedType != inputTypes.NUMBER
  "
  class="form-input"
  [class.prefixed]="
    !(selectedType == inputTypes.TEXT || selectedType == 'inputNumber') ||
    prefixIcon
  "
>
  <ng-container *ngIf="formCtrlName && formGrp; else notFormcotrol1">
    <ng-container [formGroup]="formGrp">
      <input
        [formControlName]="formCtrlName"
        [type]="
          selectedType === 'inputNumber'
            ? 'number'
            : selectedType === inputTypes.PASSWORD && showPwd
            ? 'text'
            : selectedType
        "
        [placeholder]="label"
        [required]="required"
        [attr.min]="min"
        [attr.max]="max"
        [class.valid]="getControl.touched && getControl.valid"
        [class.invalid]="getControl.touched && getControl.invalid"
        (blur)="changed(getControl.valid)"
        (change)="changeInputValue($event.target)"
        [attr.data-test]="formCtrlName"
        [attr.readonly]="readonly"
        class="{{ class }} {{ className }}"
      />
    </ng-container>
  </ng-container>
  <ng-template #notFormcotrol1>
    <input
      [type]="selectedType"
      [placeholder]="label"
      [pattern]="pattern"
      [required]="required"
      [disabled]="disabled"
      [(ngModel)]="value"
      #input="ngModel"
      [class.valid]="input.touched && input.valid"
      [attr.readonly]="readonly"
      [class.invalid]="input.touched && input.invalid"
      (change)="changeInputValue($event.target)"
      (blur)="changed(input.valid)"
      class="{{ class }} {{ className }}"
    />
  </ng-template>
  <ng-container *ngIf="selectedType == inputTypes.PASSWORD">
    <fa-icon
      *ngIf="!showPwd"
      (click)="toggleInputType(true)"
      class="eye-toggle"
      [icon]="icons.eye"
    ></fa-icon>
    <fa-icon
      *ngIf="showPwd"
      (click)="toggleInputType(false)"
      class="eye-toggle"
      [icon]="icons.eyeClose"
    ></fa-icon>
  </ng-container>

  <fa-icon
    *ngIf="selectedType == inputTypes.EMAIL"
    class="prefix"
    [icon]="icons.email"
  ></fa-icon>
  <fa-icon
    *ngIf="selectedType == inputTypes.URL"
    class="prefix"
    [icon]="icons.url"
  ></fa-icon>
  <fa-icon
    *ngIf="selectedType == inputTypes.PASSWORD"
    class="prefix"
    [icon]="icons.password"
  ></fa-icon>
  <fa-icon
    *ngIf="selectedType == inputTypes.TEL"
    class="prefix"
    [icon]="icons.tel"
  ></fa-icon>
  <fa-icon *ngIf="prefixIcon" class="prefix" [icon]="prefixIcon"></fa-icon>

  <p class="caption-text">{{ caption }}</p>
</div>
<div *ngIf="selectedType == inputTypes.NUMBER" class="form-number">
  <input
    [attr.data-test]="formCtrlName"
    [type]="selectedType"
    [required]="required"
    [disabled]="disabled"
    [(ngModel)]="value"
    #input="ngModel"
    class="{{ class }} {{ className }}"
    [class.valid]="input.touched && input.valid"
    [class.invalid]="input.touched && input.invalid"
    (blur)="changed(input.valid)"
  />
  <fa-icon
    data-test="decrement"
    class="minus"
    [icon]="icons.minus"
    (click)="decrement()"
  ></fa-icon>
  <fa-icon
    data-test="increment"
    class="plus"
    [icon]="icons.plus"
    (click)="increment()"
  ></fa-icon>
  <p class="caption-text">{{ caption }}</p>
</div>

<div *ngIf="selectedType === inputTypes.TEXTAREA" class="form-input">
  <textarea
    (change)="model.emit(value)"
    [class]="class"
    [placeholder]="label"
    [(ngModel)]="value"
    #input="ngModel"
    (blur)="changed(input.valid)"
    [attr.readonly]="readonly"
  ></textarea>
</div>

<div *ngIf="selectedType === inputTypes.LIMIT" class="form-input">
  <input
    [attr.data-test]="formCtrlName"
    [type]="selectedType"
    [required]="required"
    [disabled]="disabled"
    [(ngModel)]="value"
  />
</div>
